/**
 * @generated SignedSource<<d68c14276fe2ac4a85df54db8589f027>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AIStudioTaskState = "COMPLETED" | "ERROR" | "NO_CREDITS" | "PROCESSING" | "WAITING";
export type ProductStagingInput = {
  aspectRatio?: string | null;
  backgroundImageUrl?: string | null;
  backgroundPreset?: string | null;
  customPrompt?: string | null;
  effectPreset?: string | null;
  moodPreset?: string | null;
  productImageUrl: string;
  saveToLibrary: boolean;
  surfacePreset?: string | null;
};
export type tasksStartProductStagingMutation$variables = {
  input: ProductStagingInput;
};
export type tasksStartProductStagingMutation$data = {
  readonly startProductStaging: {
    readonly createdAt: string;
    readonly state: AIStudioTaskState;
    readonly taskId: number;
  };
};
export type tasksStartProductStagingMutation = {
  response: tasksStartProductStagingMutation$data;
  variables: tasksStartProductStagingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ProductStagingTask",
    "kind": "LinkedField",
    "name": "startProductStaging",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tasksStartProductStagingMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tasksStartProductStagingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e9315fe60e0b4d76fe39b37400446e1c",
    "id": null,
    "metadata": {},
    "name": "tasksStartProductStagingMutation",
    "operationKind": "mutation",
    "text": "mutation tasksStartProductStagingMutation(\n  $input: ProductStagingInput!\n) {\n  startProductStaging(input: $input) {\n    taskId\n    state\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "d064a1d27c7b5b9fd4069f90a643d6a0";

export default node;
